<template>
  <div class="w-100">
    <div class="w-100 clickable" @click="toggle">
      <h4><span class="badge badge-danger">{{ showing ? '--':'+' }}</span> Estado do Pagamento</h4>
    </div>

    <div class="w-100 row" v-if="showing">
      <div class="col-12 col-md-6">
        <label>Estatus do pagamento</label>
        <div class="w-100 selection-area rounded">
          <div v-for="item,i in status" :key="i" class="w-100 rounded item px-3 py-1 d-flex justify-content-between">
            <div class="pt-1">{{ item.name }}</div>
            <div>
              <button class="btn btn-sm btn-success" @click="select(item)"><i class="fa fa-plus-square"></i></button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <label>Estatus Selecionados</label>
        <div class="w-100 selection-area rounded">
          <div v-for="item,i in selectedStatus" :key="i" class="w-100 rounded item px-3 py-1 d-flex justify-content-between">
            <div class="pt-1">{{ item.name }}</div>
            <div>
              <button class="btn btn-sm btn-danger" @click="remove(item)"><i class="fa fa-minus-square"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      showing: false,
      status: [
        { id: 'S', name: 'Sucesso'},
        { id: 'W', name: 'Aguardando'},
        { id: 'P', name: 'Processando'},
        { id: 'E', name: 'Erro'}
      ],
      selectedStatus: [],
    }
  },
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  },
  methods: {
    toggle: function () {
      this.showing = !this.showing
    },

    select: function (status) {
      this.selectedStatus = [ ...this.selectedStatus, status ]
      this.status = this.status.filter( item => item.id != status.id )
    },

    remove: function (status) {
      this.status = [ ...this.status, status ]
      this.selectedStatus = this.selectedStatus.filter( item => item.id != status.id )
    }
  }
}
</script>
